/** External dependencies */
// import { Handlebars } from 'handlebars/runtime';

import { fetchHandler } from '../utilities/fetchHandler';

/**
 * Dynamically replace content using fetch.
 *
 * @param {HTMLElement} parent
 * @returns void
 */
export function replaceContent(parent) {
    const content = parent.querySelector('.ajaxcontent');
    const api = parent.dataset.ctRestReplace;
    const nonce = document.body.dataset.ctRestNonce;

    if (api && content) {
        const tmpl = parent.querySelector('.hbstmpl');

        if (!tmpl) {
            return;
        }

        const fetchOptions = {};
        if (nonce && nonce.length) {
            const headers = new Headers();
            headers.append('X-WP-Nonce', nonce);
            fetchOptions.headers = headers;
        }

        fetchHandler({ url: api, ...fetchOptions })
            .then((result) => {
                content.innerHtml = Handlebars.partials[tmpl](result);
                parent.classList.add('loaded');

                if (window.lazyLoadInstance) {
                    window.lazyLoadInstance.update();
                }
            })
            .catch((error) => {
                console.warn('There has been a problem with the replaceContent fetch operation:', error);
            });
    }
}
